export default __webpack_public_path__ + "static/media/cert7.5605d4df.jpg";